import { MdxPage } from '@features/mdx/MdxPage';
import { LanguageEnum } from '@project-types/LanguageEnum';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';



const articleIds: MdxPageArticleIds = {
	[LanguageEnum.CZ]: '88e5668c-4f26-4ac0-836f-38ceeee14138',
	[LanguageEnum.SK]: '88e5668c-4f26-4ac0-836f-38ceeee14138',
	default: '88e5668c-4f26-4ac0-836f-38ceeee14138'
}


export const Faq = () => {

	return (
		<MdxPage className='faq-page' articleIds={articleIds} />
	);
};